import Title from "common/Typography/Title";
import Button from "common/Buttons/Button";
import { Telegram } from "common/Icons/Icons";
import styled from "styled-components";
import banner_bg from "images/admin_community_banner.svg";
import dark_banner_bg from "images/dark_admin_community_banner.svg";
import Flex from "common/Boxes/Flex";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "@shared/slices/common.slice";

const AdminCommunityBanner = () => {
  const isDarkMode = useSelector(selectIsDarkMode);
  return (
    <BannerWrapper>
      <ContentWrapper>
        <img
          alt="Join Admin Community"
          src={isDarkMode ? dark_banner_bg : banner_bg}
          style={{ width: "100%" }}
        />
        <TextsWrapper>
          <StyledTitle level={3}>Join our Admin Community</StyledTitle>
          <StyledButton onClick={() => window.open(ADMIN_COMMUNITY_LINK)}>
            <TelegramIcon /> Join Us
          </StyledButton>
        </TextsWrapper>
      </ContentWrapper>
    </BannerWrapper>
  );
};

export default AdminCommunityBanner;

const ADMIN_COMMUNITY_LINK = "https://t.me/+va3IVG9EVdNiZTNk";

const BannerWrapper = styled(Flex)`
  padding: 16px;
  justify-content: center;
  position: relative;
  width: 100%;
`;
const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 240px;
  display: flex;
  align-items: center;
`;
const TextsWrapper = styled.div`
  position: absolute;
  left: 16px;
  max-width: 100px;
`;
const StyledTitle = styled(Title)`
  font-weight: ${(p) => p.theme.typography.fontWeights.EXTRA_BOLD};
  text-transform: uppercase;
  margin-bottom: 12px;
  line-height: 22px;
`;
const StyledButton = styled(Button)`
  border-color: ${(p) => p.theme.colors.primaryBlue} !important;
  color: ${(p) => p.theme.colors.primaryBlue} !important;
  background: transparent !important;
  display: flex;
  align-items: center;
  padding: 4px 12px;
`;
const TelegramIcon = styled(Telegram)`
  fill: ${(p) => p.theme.colors.primaryBlue};
  margin-right: 4px;
`;
